import { render, staticRenderFns } from "./TVODHeroSection.vue?vue&type=template&id=1ac59c72&scoped=true"
import script from "./TVODHeroSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TVODHeroSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TVODHeroSection.vue?vue&type=style&index=0&id=1ac59c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac59c72",
  null
  
)

export default component.exports